import { EventEmitter } from "events";
export const eventBus = new EventEmitter();

// New finding arrived during a live test (custom subscription
// onNewVulnerability). Listener should re-read test.vulns to pick up the
// freshly-pushed entry.
export const VULN_UPDATE = "vulnUpdate";

// A slim live-discovery event arrived mid-run (custom subscription
// onVulnerabilityDiscovered) and was appended to test.liveFindings. Drives
// the "Findings so far — test in progress" list only; the authoritative
// Open-Findings tiles and dashboard cards deliberately stay on the last
// completed test until this one terminates.
export const LIVE_FINDINGS_UPDATE = "liveFindingsUpdate";

// Local user just started a test on this webapp. Listener should re-read
// webapp.tests / webapp.testRunning and refresh the page state.
export const NEW_TEST = "newTest";

// A test record's status, end-trigger, end-time, statistics, or
// status-message changed (custom subscription onTestStatusChange).
// Emitted with the testid so listeners can ignore unrelated updates.
export const TEST_STATUS_UPDATE = "testStatusUpdate";

// A webapp's per-app aggregate (phase, vuln counts, riskscore, lastTestDate)
// was recomputed (custom subscription onWebAppTestStatusChange). Emitted
// with the webappid.
export const WEBAPP_TEST_STATUS_UPDATE = "webappTestStatusUpdate";

// An existing vuln's status, riskRating, dateFixed, etc. changed (custom
// subscription onVulnStatusChange). Emitted with the vulnid.
export const VULN_STATUS_UPDATE = "vulnStatusUpdate";

// A webapp record itself was updated — settings, schedule, ownership,
// testAcknowledged, etc. (custom subscription onWebApplicationChange).
// Emitted with the webappid.
export const WEBAPP_UPDATE = "webappUpdate";

// The tenant's license slots changed — a purchase completed, or the user
// closed the checkout modal and we can't assume they didn't buy. Every mounted
// useTenantEntitlements instance refetches and rewrites the cache, so the
// Add-App picker, the Applications rows and the Pentest gate all pick up a
// newly-bought license without a reload.
//
// Provisioning is asynchronous (Stripe webhook), so the emitter is expected to
// fire this more than once after a payment — the new slot may not exist yet on
// the first attempt.
export const ENTITLEMENTS_UPDATE = "entitlementsUpdate";
